var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3248 26.9984L26.8172 24.9425C26.7147 24.8027 26.5209 24.7671 26.3754 24.8613C24.403 26.1376 23.8608 28.0872 24.6521 29.5244C25.5175 31.0961 26.8523 33.0237 28.8996 35.0711C30.947 37.1185 32.8746 38.4532 34.4464 39.3187C35.8836 40.11 37.8332 39.5678 39.1095 37.5954C39.2036 37.4498 39.168 37.2561 39.0282 37.1535L36.9723 35.6459C36.67 35.4242 36.2691 35.3902 35.9338 35.5579L35.1143 35.9676C34.4173 36.3161 33.4619 36.4385 32.5575 35.9732C31.9528 35.6622 31.0209 35.071 29.9603 34.0104C28.8998 32.9499 28.3086 32.0179 27.9975 31.4133C27.5322 30.5089 27.6547 29.5534 28.0031 28.8564L28.4129 28.037C28.5805 27.7017 28.5466 27.3007 28.3248 26.9984ZM25.2889 23.1822C22.7484 24.826 21.4406 27.8383 22.9001 30.489C23.8526 32.219 25.2995 34.2994 27.4854 36.4853C29.6714 38.6713 31.7518 40.1181 33.4817 41.0706C36.1325 42.5301 39.1447 41.2224 40.7886 38.6819C41.4582 37.647 41.2049 36.2696 40.2109 35.5407L38.1551 34.0331C37.2481 33.368 36.0453 33.266 35.0393 33.769L34.2199 34.1788C33.9827 34.2974 33.7083 34.3161 33.4724 34.1948C33.0428 33.9737 32.2813 33.503 31.3745 32.5962C30.4677 31.6894 29.997 30.928 29.776 30.4983C29.6546 30.2625 29.6734 29.9881 29.792 29.7509L30.2017 28.9314C30.7047 27.9255 30.6028 26.7227 29.9377 25.8157L28.43 23.7598C27.7011 22.7659 26.3237 22.5126 25.2889 23.1822Z",
    fill: "#1A1D1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#EFEFEF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fa2da4f12ec5253a6cd6512043055d45.svg";
export { ForwardRef as ReactComponent };